import asyncComponent from "../../helpers/AsyncFunc";

export function addRouteComponent(flattenRoutes, getComponent, getProvider = () => ({})) {
    return flattenRoutes.map(route => ({
        ...route,
        component: asyncComponent(getComponent(route.id), getProvider(route.id)),
    }));
}
